import { render, staticRenderFns } from "./FeathersServiceTable.vue?vue&type=template&id=5e80e619&"
import script from "./FeathersServiceTable.vue?vue&type=script&lang=js&"
export * from "./FeathersServiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e80e619')) {
      api.createRecord('5e80e619', component.options)
    } else {
      api.reload('5e80e619', component.options)
    }
    module.hot.accept("./FeathersServiceTable.vue?vue&type=template&id=5e80e619&", function () {
      api.rerender('5e80e619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeathersServiceTable.vue"
export default component.exports